import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom"; // updated
import "./slideBar.css";
import Logo from "../../assets/dc-logo.png";
import { userLogOut } from "../../pages/admin-dashboard-page/userAction";

export const SlideBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // updated
  const { pathname } = useLocation();
  const [toggle, setToggle] = useState(true);
  const { user } = useSelector((state) => state.user);

  const clsNms = toggle ? "left-bar" : "left-bar hide";

  const logMeOut = () => {
    dispatch(userLogOut());
    navigate("/"); // updated
  };

  return (
    <aside className={clsNms}>
      <div className="text-end text-secondary" style={{ cursor: "pointer" }}>
        <i
          className="fas fa-arrows-alt-h fs-3 p-2"
          onClick={() => setToggle(!toggle)}
        ></i>
      </div>

      <div className="sidebar">
        <div className="admin-logo p-2 text-center font-weight-bold">
          <img className="logo" src={Logo} alt="logo" />
        </div>
        <hr className="divider" />
        <div className="sidebar-nav">
          <ul className={toggle ? "sidebar-nav-ul" : "sidebar-nav-ul short"}>
            <Link
              to="/dashboard"
              className={
                pathname.includes("/dashboard") ? "sidebar-active" : ""
              }
            >
              <i className="fas fa-tv"></i>
              <span className={toggle ? "" : "link-name"}>Dashboard</span>
            </Link>

            <Link
              to="/pre-enrolment"
              className={
                pathname.includes("/pre-enrolment") ? "sidebar-active" : ""
              }
            >
              <i className="fas fa-users"></i>
              <span className={toggle ? "" : "link-name"}>Pre-Enrolment</span>
            </Link>

            <Link
              to="/enrol"
              className={pathname.includes("/enrol") ? "sidebar-active" : ""}
            >
              <i className="fa-solid fa-book-open-reader"></i>
              <span className={toggle ? "" : "link-name"}>Enrolment</span>
            </Link>

            <Link
              to="/leads"
              className={pathname.includes("/leads") ? "sidebar-active" : ""}
            >
              <i className="fas fa-sitemap"></i>
              <span className={toggle ? "" : "link-name"}>Leads</span>
            </Link>

            {user?.role === "admin" && (
              <>
                <Link
                  to="/blog"
                  className={pathname.includes("/blog") ? "sidebar-active" : ""}
                >
                  <i className="fas fa-blog"></i>
                  <span className={toggle ? "" : "link-name"}>Blogs</span>
                </Link>

                <Link
                  to="/careers"
                  className={
                    pathname.includes("/careers") ? "sidebar-active" : ""
                  }
                >
                  <i className="fas fa-briefcase"></i>
                  <span className={toggle ? "" : "link-name"}>Careers</span>
                </Link>

                <Link
                  to="/testimonial"
                  className={
                    pathname.includes("/testimonial") ? "sidebar-active" : ""
                  }
                >
                  <i className="fas fa-quote-left"></i>
                  <span className={toggle ? "" : "link-name"}>
                    Testimonials
                  </span>
                </Link>

                <Link
                  to="/events"
                  className={
                    pathname.includes("/events") ? "sidebar-active" : ""
                  }
                >
                  <i className="fas fa-calendar-alt"></i>
                  <span className={toggle ? "" : "link-name"}>Events</span>
                </Link>

                <Link
                  to="/course"
                  className={
                    pathname.includes("/course") ? "sidebar-active" : ""
                  }
                >
                  <i className="fas fa-book"></i>
                  <span className={toggle ? "" : "link-name"}>Courses</span>
                </Link>

                <Link
                  to="/student"
                  className={
                    pathname.includes("/student") ? "sidebar-active" : ""
                  }
                >
                  <i className="fas fa-user-graduate"></i>
                  <span className={toggle ? "" : "link-name"}>Student</span>
                </Link>

                <Link
                  to="/reviews"
                  className={
                    pathname.includes("/reviews") ? "sidebar-active" : ""
                  }
                >
                  <i className="fas fa-star"></i>
                  <span className={toggle ? "" : "link-name"}>Reviews</span>
                </Link>

                <Link
                  to="/ambassadors"
                  className={
                    pathname.includes("/ambassadors") ? "sidebar-active" : ""
                  }
                >
                  <i className="fas fa-users-cog"></i>
                  <span className={toggle ? "" : "link-name"}>Ambassadors</span>
                </Link>

                <Link
                  to="/staffs"
                  className={
                    pathname.includes("/staffs") ? "sidebar-active" : ""
                  }
                >
                  <i className="fas fa-user"></i>
                  <span className={toggle ? "" : "link-name"}>Staff</span>
                </Link>

                <Link
                  to="/free-resources"
                  className={
                    pathname.includes("/free-resources")
                      ? "sidebar-active"
                      : ""
                  }
                >
                  <i className="fas fa-gift"></i>
                  <span className={toggle ? "" : "link-name"}>
                    Free Resources
                  </span>
                </Link>
              </>
            )}

            <Link
              to="/settings"
              className={pathname.includes("/settings") ? "sidebar-active" : ""}
            >
              <i className="fas fa-cogs"></i>
              <span className={toggle ? "" : "link-name"}>Settings</span>
            </Link>

            <li onClick={logMeOut} className="logout">
              <i className="fas fa-power-off"></i>
              <span className={toggle ? "" : "link-name"}>Logout</span>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  );
};
